import Vue from 'vue';
// import * as smth from 'iview';
import locale from 'iview/dist/locale/en-US';
import '../iview-variables.less';

const iView = require('iview');

Vue.use(iView, { locale });
